import { ILatLon } from "./Models";
import { GeoAccuracy } from "../Enums/GeoAccuracy";

export interface IGeocodeResponse {
  coordinates: ILatLon;
  geoAccuracy: GeoAccuracy;
}
